<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="题号123123" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['questionNumber']" placeholder="请输入题号" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['title']" rows="4" placeholder="请输入标题"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="问卷描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['templateDescribe']" rows="4" placeholder="请输入问卷描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="类型模板、问题、答案 " :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['type']" placeholder="请输入类型模板、问题、答案 "></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['labelName']" placeholder="请输入标签"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="模板类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['templateType']" placeholder="请输入模板类型"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="答卷次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['count']" placeholder="请输入答卷次数" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发布" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isRelease']" ></j-switch>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发布时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择发布时间" v-decorator="['releaseTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="必答题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isWillAnswer']" ></j-switch>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否显示序号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isShowNumber']" ></j-switch>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="默认文本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['defaultText']" placeholder="请输入默认文本"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="格式限制" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['formatLimit']" placeholder="请输入格式限制"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="最小字数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['minWords']" placeholder="请输入最小字数" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="最多字数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['maxWords']" placeholder="请输入最多字数" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="默认跳转下一题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['jumpQuestion']" placeholder="请输入默认跳转下一题" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import JSwitch from '@/components/jeecg/JSwitch'

  export default {
    name: 'QuestionRuleAllModal',
    components: {
      JFormContainer,
      JDate,
      JSwitch,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/questionAll/questionAll/add",
          edit: "/questionAll/questionAll/edit",
          queryById: "/questionAll/questionAll/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'questionNumber','title','templateDescribe','type','labelName','templateType','count','isRelease','releaseTime','isWillAnswer','isShowNumber','defaultText','formatLimit','minWords','maxWords','jumpQuestion'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'questionNumber','title','templateDescribe','type','labelName','templateType','count','isRelease','releaseTime','isWillAnswer','isShowNumber','defaultText','formatLimit','minWords','maxWords','jumpQuestion'))
      },
    }
  }
</script>